// extracted by mini-css-extract-plugin
module.exports = {"chip":"styles_chip__SpEB0","imageOverlay":"styles_imageOverlay__Pr2Xu"};